var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "confirm-wrapper"
  }, [_c('div', {
    staticClass: "confirm-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm.title ? _c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.message))])]), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "btn cancel",
    class: {
      'strong': _vm.strongButton === 'cancel'
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _c('div', {
    staticClass: "btn confirm",
    class: {
      'strong': _vm.strongButton === 'confirm'
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };